module.exports = __webpack_public_path__ + "static/media/titileTop.9afddd25.png";